angular.module('unica_event_field.event_field_controllers', [])

.controller('EventFieldBasicController',
	function(
		$rootScope, $scope, $stateParams,
		EventFieldListService, InvitationListListService,
		FeedbackCategoryListService
	) {

	$scope.forms = {};

	$rootScope.eventFieldData = {
		event_id: $stateParams.event_id
	};

	$scope.$on('event_loaded', function() {
		$scope.year = $rootScope.year;
	});

	$scope.invitationsLists = [];

	$scope.feedbackCategories = [];

	$scope.loadInvitationsLists = function() {
		$scope.showLoader();

		InvitationListListService
			.fullList( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {
					$scope.invitationsLists = data;
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadFeedbackCategories = function() {
		$scope.showLoader();

		FeedbackCategoryListService
			.fullList( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {
					$scope.feedbackCategories = data;
				} else {
					$rootScope.manageError(data);
				}
			});
	};


	$scope.loadInvitationsLists();
	$scope.loadFeedbackCategories();

	$scope.friendlyFieldName = function( fieldName )
	{
		if ( fieldName.substr(0, 7) === 'custom_' ) {
			fieldName = fieldName.substr(7);
		}
		fieldName = fieldName
			.replaceAll('_', ' ');

		return fieldName;
	}

	$scope.addCondition = function()
	{
		if ( !$rootScope.eventFieldData.conditions ) $rootScope.eventFieldData.conditions = [];
		$rootScope.eventFieldData.conditions.push({field:'',compare:'',value:''});
	};

	$scope.removeCondition = function( index )
	{
		$rootScope.eventFieldData.conditions.splice( index, 1 );
	};

	$scope.addFieldOption = function()
	{
		$rootScope.eventFieldData.options.push({name:'',label:''});
	};

	$scope.removeFieldOption = function( index )
	{
		$rootScope.eventFieldData.options.splice( index, 1 );
	};

	$scope.parseFieldName = function( fieldName )
	{
		fieldName = fieldName
			.toLowerCase()
			.replaceAll(/[^a-z0-9 \_]/g, "")
			.replaceAll(' ', '_');

		// console.log(fieldName.substr(0,7));
		if ( fieldName.substr(0, 7) !== 'custom_' ) {
			fieldName = 'custom_' + fieldName;
			// console.log( fieldName );
		}

		return fieldName;
	}

	$scope.typologies = {
		yn: 'Si/No',
		text: 'Testo Breve',
		textarea: 'Area di Testo',
		select: 'Scelta',
		image: 'Caricamento Foto',
		file: 'Caricamento File',
		label: 'Solo Testo',
	};

	$rootScope.getEventField = function(eventFieldId)
	{
		$scope.showLoader();

		EventFieldListService
			.get(eventFieldId)
			.then(function(data) {
				$scope.hideLoader();

				data.name = $scope.friendlyFieldName( data.name );

				if ( data.options && data.options.length > 0 ) {
					angular.forEach(data.options, function(opt, key) {
						data.options[key].name = $scope.friendlyFieldName( opt.name );
					});
				}

				$rootScope.eventFieldData = data;

				$scope.disableFiscalCode = false;
				$scope.disableNet = false;
				$scope.disableAgencyCode = false;
				if ( $rootScope.eventFieldData.format_filename && $rootScope.eventFieldData.format_filename !== '' ) {

					if ( $rootScope.eventFieldData.format_filename.includes( $scope.formatPlaceholder.fiscal_code ) ) {
						$scope.disableFiscalCode = true;
					}
					if ( $rootScope.eventFieldData.format_filename.includes( $scope.formatPlaceholder.agency_code ) ) {
						$scope.disableAgencyCode = true;
					}
					if ( $rootScope.eventFieldData.format_filename.includes( $scope.formatPlaceholder.net ) ) {
						$scope.disableNet = true;
					}
				}

			});
	};


	$scope.formatPlaceholder = {
		fiscal_code: "{{ Codice Fiscale }}",
		agency_code: "{{ Codice Agenzia }}",
		net: "{{ Rete Vendita }}"
	};


		$scope.disableFiscalCode = false;
		$scope.addFiscalCodeToFilename = function() {
			if ( !$rootScope.eventFieldData.format_filename ) {
				$rootScope.eventFieldData.format_filename = '';
			} else if ( $rootScope.eventFieldData.format_filename !== '' ) {
				$rootScope.eventFieldData.format_filename += '_';
			}
			$rootScope.eventFieldData.format_filename += $scope.formatPlaceholder.fiscal_code;
			$scope.disableFiscalCode = true;
		}

		$scope.disableNet = false;
		$scope.addNetToFilename = function() {
			if ( !$rootScope.eventFieldData.format_filename ) {
				$rootScope.eventFieldData.format_filename = '';
			} else if ( $rootScope.eventFieldData.format_filename !== '' ) {
				$rootScope.eventFieldData.format_filename += '_';
			}
			$rootScope.eventFieldData.format_filename += $scope.formatPlaceholder.net;
			$scope.disableNet = true;
		}

		$scope.disableAgencyCode = false;
		$scope.addAgencyCodeFilename = function() {
			if ( !$rootScope.eventFieldData.format_filename ) {
				$rootScope.eventFieldData.format_filename = '';
			} else if ( $rootScope.eventFieldData.format_filename !== '' ) {
				$rootScope.eventFieldData.format_filename += '_';
			}
			$rootScope.eventFieldData.format_filename += $scope.formatPlaceholder.agency_code;
			$scope.disableAgencyCode = true;
		}

		$scope.resetFilename = function() {
			$rootScope.eventFieldData.format_filename = '';
			$scope.disableFiscalCode = false;
			$scope.disableNet = false;
			$scope.disableAgencyCode = false;
		}



		$scope.disableImages = false;
		$scope.addImagesToAllowed = function() {
			if ( !$rootScope.eventFieldData.allowed_types || $rootScope.eventFieldData.allowed_types === '*' ||
				$rootScope.eventFieldData.allowed_types === '.*' ) {
				$rootScope.eventFieldData.allowed_types = '';
			} else if ( $rootScope.eventFieldData.allowed_types !== '' ) {
				$rootScope.eventFieldData.allowed_types += ', ';
			}
			$rootScope.eventFieldData.allowed_types += '.jpg, .png, .jpeg, .gif';
			$scope.disableImages = true;
		}



		$scope.disableVideo = false;
		$scope.addVideoToAllowed = function() {
			if ( !$rootScope.eventFieldData.allowed_types || $rootScope.eventFieldData.allowed_types === '*' ||
				$rootScope.eventFieldData.allowed_types === '.*' ) {
				$rootScope.eventFieldData.allowed_types = '';
			} else if ( $rootScope.eventFieldData.allowed_types !== '' ) {
				$rootScope.eventFieldData.allowed_types += ', ';
			}
			$rootScope.eventFieldData.allowed_types += '.mp4, .mov';
			$scope.disableVideo = true;
		}


		$scope.disableDocx = false;
		$scope.addDocxToAllowed = function() {
			if ( !$rootScope.eventFieldData.allowed_types || $rootScope.eventFieldData.allowed_types === '*' ||
				$rootScope.eventFieldData.allowed_types === '.*' ) {
				$rootScope.eventFieldData.allowed_types = '';
			} else if ( $rootScope.eventFieldData.allowed_types !== '' ) {
				$rootScope.eventFieldData.allowed_types += ', ';
			}
			$rootScope.eventFieldData.allowed_types += '.docx';
			$scope.disableDocx = true;
		}


		$scope.disableDoc = false;
		$scope.addDocToAllowed = function() {
			if ( !$rootScope.eventFieldData.allowed_types || $rootScope.eventFieldData.allowed_types === '*' ||
				$rootScope.eventFieldData.allowed_types === '.*' ) {
				$rootScope.eventFieldData.allowed_types = '';
			} else if ( $rootScope.eventFieldData.allowed_types !== '' ) {
				$rootScope.eventFieldData.allowed_types += ', ';
			}
			$rootScope.eventFieldData.allowed_types += '.doc';
			$scope.disableDoc = true;
		}


		$scope.disablePdf = false;
		$scope.addPdfToAllowed = function() {
			if ( !$rootScope.eventFieldData.allowed_types ||
				$rootScope.eventFieldData.allowed_types === '*' ||
				$rootScope.eventFieldData.allowed_types === '.*' ) {
				$rootScope.eventFieldData.allowed_types = '';
			} else if ( $rootScope.eventFieldData.allowed_types !== '' ) {
				$rootScope.eventFieldData.allowed_types += ', ';
			}
			$rootScope.eventFieldData.allowed_types += '.pdf';
			$scope.disablePdf = true;
		}

		$scope.resetAllowed = function() {
			$rootScope.eventFieldData.allowed_types = '*';
			$scope.disableImages = false;
			$scope.disableDocx = false;
			$scope.disableDoc = false;
			$scope.disablePdf = false;
			$scope.disableVideo = false;
		}

});


